import React, { useEffect, useState } from 'react'
import S from '../../pages/ListDam.module.css'
import InfoIcon from '@mui/icons-material/Info';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import './cattleListCard.css'
import apiService from '../../api/ApiService'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import EmptyReturn from '../EmptyReturn';
const moment=require('moment-jalaali')

const CattleListCardDash = () => {
  const {currentAdmin,currentTheme}=useSelector(state=>state.p.admin)

  const [data,setData]=useState([]);
  const [page,setPage]=useState(0);
  const [hasmore,sethaseMore]=useState(true)
  const handlePage=()=>{
    if(hasmore){
setPage(page+10)

    }
}
  const getData=async()=>{

    
    const data=JSON.stringify({
      "skip": page,
      "take": 10,
      "fromDate": null,
      "toDate": null,
      "penIds":[],
      "hasSensor":true
    })
   
      const res=await apiService.getAllCattles(currentAdmin?.id,data)
      setData((result)=>[...result,...res.data.data])
      if(res.data.data.length<10){
        sethaseMore(false)
      }       
  
  }
  useEffect(()=>{
    getData()
  },[page])
  return (
    <div style={{direction:'rtl',padding:'24px'}}>
    <div className='BodyList'>

      <div className='CardContAllCattle'>
        <div className={S.AnimContentLI} style={{boxShadow:"none"}} data-aos='fade'>
        <span style={{fontSize:'20px',margin:'10px'}}>⭕ دام  های با وضعیت غیر عادی</span>
        <hr/>
        {data?.length?<table>
              <thead>
                <tr>
                  <th>
                    ردیف
                  </th>
                  <th>
                    وضعیت
                  </th>
                  <th>
                    گردنبند
                  </th>
                  <th>
                    شماره گوش
                  </th>
                  <th>
                    شماره بدن
                  </th>
                  <th>
                    جنسیت
                  </th>
                  <th>
                    تاریخ تولد
                  </th>
                  
                  <th>
                    جزئیات
                  </th>
                </tr>
              </thead>
              <tbody>
                {
                  data?.length&&data?.map((item,index)=>{
                    const {birthdate}=item;
                    const birth=birthdate?.substring(0,10);
                    const pbirth=moment(birth).format('jYYYY-jMM-jDD')
                    return <tr key={index}>
                    <td>
                      {index+1}
                    </td>
                    <td>
                      {item.cattleStatusId==0?' 🟢':' 🔴'}
                    </td>
                    <td>
                      {item.sensor?.deviceCode}
                    </td>
                    <td>
                      {item.earTagNumber}
                    </td>
                    <td>
                      {item.bodyNumber}
  
                    </td>
                    <td>
                      {item.gender===2?'ماده':'نر'}
                    </td>
                    <td>
                      {pbirth}
                    </td>
                   
                    <td className={S.DetIc}>
                      <Link to={`/listdam/${item.id}`}>
                      <InfoIcon/>
                      </Link>
                    </td>
                  </tr>
                  
                  })
                }
                
                
                
                
                

              </tbody>
            </table>:<EmptyReturn/>}
        </div>
      </div>
      {hasmore&&<div  className='AddIConTotheList'>
  <AddCircleOutlineIcon sx={{fontSize: { xs: 26, sm: 30, md: 30, lg:30} }} className='AddIconToTheListmain' onClick={handlePage}/>
</div>
}
    </div>  
    </div>
  )
}

export default CattleListCardDash
